import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const DEFAULTS = { name: "K Gestionale", support_email: "", support_whatsapp: "" };
let cache = null;

// Dati pubblici della piattaforma (nome e contatti assistenza).
export const usePlatform = () => {
  const [info, setInfo] = useState(cache || DEFAULTS);
  useEffect(() => {
    const load = () => axios.get(`${API}/platform/info`).then((r) => { cache = r.data; setInfo(r.data); }).catch(() => {});
    if (!cache) load();
    window.addEventListener("platform-updated", load);
    return () => window.removeEventListener("platform-updated", load);
  }, []);
  return info;
};

export const waLink = (num) => `https://wa.me/${String(num || "").replace(/[^\d]/g, "")}`;
